import { useIntl } from "react-intl";
import { Box, Typography } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";

import { getModelLabel } from "./constants";
import { MLMetrics } from "./services";

const ActiveModelBanner = ({ model }: { model: MLMetrics }) => {
  const intl = useIntl();

  return (
    <Box
      sx={{
        background: (theme) => theme.vars.palette.nancie.gradient,
        borderRadius: 2,
        px: 3,
        py: 1.5,
        display: "flex",
        alignItems: "center",
        gap: 1.5,
      }}
    >
      <CheckCircleIcon sx={{ color: "common.white", flexShrink: 0 }} />
      <Box>
        <Typography
          sx={{
            fontWeight: 700,
            color: "common.white",
            fontSize: "0.9rem",
          }}
        >
          Modèle actif en production : {getModelLabel(model.model_name)}
        </Typography>
        <Typography
          sx={{ color: "rgba(255,255,255,0.85)", fontSize: "0.8rem" }}
        >
          Ce modèle est actuellement utilisé pour générer les prévisions
          d'annulation.
          {model.training_start_date && model.training_end_date ? (
            <>
              {" "}
              Il a été entraîné sur les données du{" "}
              {intl.formatDate(model.training_start_date)} au{" "}
              {intl.formatDate(model.training_end_date)}.
            </>
          ) : null}
        </Typography>
      </Box>
    </Box>
  );
};

export default ActiveModelBanner;
